import { createGlobalStyle } from 'styled-components'
import { operationsStatusColors } from './shared/utils/toothHelpers'

export const GlobalStyle = createGlobalStyle`
  :root {
    --main-background: #f0f4f9;
    --main-gradient: ${props => (props.medicolize ? '#41305d' : '#044D80')};
    --main-color: ${props => (props.medicolize ? '#743B8F' : '#0477b9')};
    --main-gradientH: ${props => (props.medicolize ? '#41305d' : '#044D80')};
    --menu-main-gradient: ${props => (props.medicolize ? '#41305d' : '#044D80')};
    --menu-main-gradient2: ${props => (props.medicolize ? '#41305d' : '#044D80')};
    --menu-main-gradient2RTL: ${props => (props.medicolize ? '#41305d' : '#044D80')};
    --menu-highlight: ${props => (props.medicolize ? '#231333' : '#03223b')};
    --color-transparent: ${props => (props.medicolize ? 'rgba(196,152,237,0.14)' : '#98dbed24')};
    --sidebar-width: 200px;
    --header-height: 50px;
    --sub-menu: ${props => (props.medicolize ? '#341C4C' : '#002f54')};
    --patient-box-shadow: ${props => (props.medicolize ? 'rgba(100,0,194,0.4)' : 'rgba(0, 99, 193, 0.4)')};
    --closed-time-color: #ffd7d2;
    --ant-error-color: ${props => (props.medicolize ? '#a51214' : '#ff4d4f')};
    --ant-error-color-active: #d9363e;
    --ant-error-color-hover: #ff7875;
    --ant-primary-1: ${props => (props.medicolize ? '#eee1fa' : '#e1f5fa')};
    --ant-primary-2: ${props => (props.medicolize ? '#f3e6ff' : '#e6f7ff')};
    --ant-primary-3: ${props => (props.medicolize ? '#b884d0' : '#6cc3e0')};
    --ant-primary-4: ${props => (props.medicolize ? '#9962b2' : '#44abd4')};
    --ant-primary-5: ${props => (props.medicolize ? '#7c4a93' : '#2092c7')};
    --ant-primary-6: ${props => (props.medicolize ? '#653e77' : '#0077b9')};
    --ant-primary-7: ${props => (props.medicolize ? '#4f2d5e' : '#005b94')};
    --ant-primary-8: ${props => (props.medicolize ? '#432352' : '#00406e')};
    --ant-primary-9: ${props => (props.medicolize ? '#281233' : '#002747')};
    --ant-primary-10: ${props => (props.medicolize ? '#110021' : '#001121')};
    --ant-primary-color: ${props => (props.medicolize ? 'rgb(74,44,101)' : 'rgb(0, 119, 185)')};
    --ant-primary-color-active: ${props => (props.medicolize ? '#39006e' : '#00406e')};
    --ant-primary-color-disabled: ${props => (props.medicolize ? '#c498ed' : '#98dbed')};
    --ant-primary-color-hover: ${props => (props.medicolize ? '#7620c7' : '#2092c7')};
    --ant-success-color: #52c41a;
    --ant-success-color-active: #389e0d;
    --ant-success-color-hover: #73d13d;
    --ant-warning-color: #faad14;
    --ant-warning-color-active: #d48806;
    --ant-warning-color-hover: #ffc53d;
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    font-family: "Lato", "El Messiri", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif !important;
  }

  html {
    background-color: var(--main-background);
  }

  body {
    margin: 0;
    font-family: "Lato", "El Messiri", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .hide-exept-on-print {
    display: none;
  }
  
  @media print {
    .hide-on-print {
      display: none !important;
    }
    
    .hide-exept-on-print {
      display: block !important;
    }
  }

  ul {
    padding-inline-start: 0;
  }

  p,
  span,
  a {
    font-weight: 400;
  }

  .ant-typography a, a, .ant-typography .ant-typography-expand, a button:not(.ant-btn-primary):not(.ant-btn-default), a button:not(.ant-btn-primary):not(.ant-btn-default) span, .ant-btn-link:not(.ant-btn-dangerous) {
    color: var(--ant-primary-color);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  button:not(.ant-btn-sm) {
    font-weight: 700 !important;
  }

  .ant-menu-submenu.ant-menu-submenu-popup.ant-menu {
    .ant-menu.ant-menu-sub.ant-menu-vertical {
      max-height: 40vh;
      overflow: scroll;
    }
  }

  //Make tables smaller
  .ant-table-wrapper .ant-table.ant-table-small .ant-table-tbody > tr > td {
    padding: 3px;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
  }

  .ant-tooltip-inner .ant-badge {
    color: inherit;
    padding-right: 10px;
  }

  .ant-input-search-icon.anticon {
    color: rgba(0, 0, 0, 0.45);
  }

  .ant-tabs-dropdown-menu-item .anticon svg,
  .ant-menu-item-icon.anticon svg {
    width: 1.2rem;
  }

  .button-item-icon svg {
    width: 27px;
    height: 27px;
  }

  .main-float {
    width: auto;
    right: ${props => (props.rtl ? 'auto' : '10px')};
    left: ${props => (props.rtl ? '10px' : 'auto')};

    .ant-float-btn-icon svg {
      width: 0.9em;
      height: 0.9em;
    }
  }

  .hidden-float {
    width: auto;
    right: ${props => (props.rtl ? 'auto' : '-20px')};
    left: ${props => (props.rtl ? '-20px' : 'auto')};
    min-height: 25px !important;

    .ant-float-btn {
      min-height: 25px !important;
      padding: 0 !important;
    }

    .ant-float-btn-body {
      width: 25px !important;
      height: 25px !important;
    }

    .ant-float-btn-content {
      min-height: 25px !important;
      width: 25px;
    }

    .ant-float-btn-icon {
      margin-top: 0 !important;
      margin-bottom: 8px !important;

      svg {
        width: 0.5em;
        height: 0.5em;
      }
    }
  }

  .age-birth-switch {
    position: absolute;
    top: 5px;
    right: ${props => (props.rtl ? 'auto' : '8px')};
    left: ${props => (props.rtl ? '8px' : 'auto')};
  }

  .time-selector-icon {
    position: absolute;
    top: 0;
    right: ${props => (props.rtl ? 'auto' : '10px')};
    left: ${props => (props.rtl ? '10px' : 'auto')};
  }

  .flex-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .flex {
    display: flex;
  }

  .justify-center {
    justify-content: center;
  }

  .flex-column {
    flex-direction: column;
  }

  .flex-reverse {
    flex-direction: row-reverse;
  }

  .justify-end {
    justify-content: flex-end;
  }

  .align-start {
    align-items: flex-start;
  }

  .align-stretch {
    align-items: stretch;
  }

  .missing-tooth > .ant-tag {
    background: #b4b4b4;
  }

  .justify-between {
    justify-content: space-between;

    &.ant-space-align-center {
      justify-content: space-between !important;
    }
  }

  .reverse-flex {
    flex-direction: row-reverse;
  }

  .no-wrap {
    flex-wrap: nowrap;
  }

  a[href^="tel:"] {
    direction: ltr;
  }

  .flex-1 {
    align-items: stretch;

    > div {
      flex: 1;
    }
  }

  a[disabled], a.disabled-link {
    pointer-events: none;
    color: rgba(0, 0, 0, .85);
  }

  .center {
    text-align: center;
  }

  //Styles For Patient Referral Select
  .show-button-hover {
    button {
      opacity: 0;
    }
  }

  .qr-code-modal {
    background: rgba(2, 25, 44, 0.97);

    .ant-modal-confirm-body {
      justify-content: center
    }
  }

  .ant-modal-confirm-content {
    width: 100%;
  }

  .ant-modal-title .phone-number-text {
    margin: 0;
  }

  .mb0 {
    margin-bottom: 0 !important;
  }

  .mt0 {
    margin-top: 0 !important;
  }

  .mb-half {
    margin-bottom: 0.5rem;
  }

  .ant-select-item-option-active .show-button-hover button {
    opacity: 1;
  }

  .ant-select-selection-item .show-button-hover button {
    display: none;
  }

  .hidden-element {
    display: none !important;
  }

  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
    background: #eaeaea;
  }

  /*Fixing sub menu background on mobile*/
  .ant-menu-sub.ant-menu-vertical {
    background: var(--sub-menu) !important;

    .ant-menu-item-selected {
      background: var(--menu-highlight) !important;
    }
  }

  .ant-popover {
    z-index: 1050;

    &.monthly-calendar {
      .ant-popover-inner {
        max-height: 50vh;
      }
    }
  }

  .ant-popover-inner {
    max-width: 95vw !important;
    max-height: 70vh;
    overflow: scroll;
  }

  .columns-popover .ant-popover-inner {
    max-height: 70vh;
    overflow: scroll;
  }

  .mentions-container {
    direction: ltr !important;
  }

  /*Fixing menu header when off hover*/
  .ant-menu-submenu-hidden {
    opacity: 0 !important;
  }

  .header-popover {
    .ant-popover-arrow {
      display: none;
    }

    .ant-popover-inner {
      padding: 0;
    }
  }


  //Arabic fixes
  .ant-menu-submenu-popup.ant-menu-submenu .ant-badge,
  .ant-menu-inline-collapsed-tooltip .ant-badge {
    color: inherit;
    position: relative;

    .ant-badge-count {
      right: -22px;
      box-shadow: none;
      transform: translate(0px, -50%);

      &.ant-badge-multiple-words {
        right: -32px;
      }
    }

    &.ant-badge-rtl .ant-badge-count {
      left: -22px;
      right: auto;

      &.ant-badge-multiple-words {
        left: -32px;
      }
    }
  }

  .ant-back-top-content {
    background-color: rgba(0, 47, 84, 0.4);

    &:hover {
      background-color: rgba(0, 47, 84, 0.8);
    }
  }

  .ant-input-number-affix-wrapper-rtl .ant-input-number-suffix {
    right: auto;
    left: 0;
  }

  .ant-popover-rtl .ant-popover-buttons {
    text-align: right;
  }

  .ant-menu-submenu-rtl .ant-menu-submenu {
    text-align: right;
  }


  .ant-descriptions-rtl .ant-descriptions-item-content {
    strong {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .ant-table-rtl .ant-table-cell .ant-typography-rtl strong {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  form .phoneNumberField .ant-form-item-control-input input,
  .tablePhoneNumber .ant-tag,
  .direction-ltr {
    direction: ltr;
  }

  .phone-number-text {
    direction: ltr !important;
  }

  .carousel-root .carousel .slide img {
    max-height: 70vh;
    width: auto;
    max-width: 100%;
  }

  .phoneNumberField.ant-form-item {
    .ant-form-item-children-icon {
      right: 0 !important;
      left: auto !important;
    }

    .ant-input-group-wrapper-rtl, .ant-input-group {
      direction: ltr;

      > input {
        border-radius: 0 2px 2px 0;
        padding-right: 24px;
        padding-left: 11px;
      }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */

    input[type=number] {
      -moz-appearance: textfield;
    }

    .ant-input-group-addon {
      padding: 0;
      border: 0;

      input {
        width: 60px;
        border-radius: 6px 0 0 6px;
        border-right: 0;
        padding: 4px;
      }
    }
  }

  .ant-menu-submenu-rtl .ant-menu-item:not(.attendance-menu) .ant-menu-title-content {
    margin-left: 0;
    margin-right: 10px;
  }

  .ant-select-multiple {
    cursor: text;
  }

  .ant-form-item-control {
    max-width: 100%;
  }

  .qr-image-logo {
    max-width: 100%;
    margin: 0 auto;

    &.company-logo {
      width: auto !important;
      max-height: 150px;
      max-width: 250px !important;
    }
  }

  .noPaddingResult {
    .ant-result {
      padding: 0;
    }
  }

  .no-wrap, .no-wrap strong, .no-wrap span {
    white-space: nowrap;
  }

  .ant-table-cell .ant-typography, .ant-descriptions-item-content .ant-typography {
    white-space: pre-line;
  }

  span.ant-typography mark {
    padding: 0 5px;
  }

  .ant-form-item-has-error .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    border-color: var(--ant-error-color);
  }

  .ant-btn-primary.ant-btn-dangerous {
    background-color: var(--ant-error-color);
  }

  .ant-menu-inline-collapsed-tooltip a {
    color: inherit;
  }

  .ant-btn-primary a, .ant-btn-dangerous a {
    color: inherit;
  }

  button.successFill:not([disabled]),
  .successFill > button:not([disabled]) {
    background: ${operationsStatusColors.COMPLETED};
    border-color: ${operationsStatusColors.COMPLETED};
    color: #ffffff !important;

    &:hover, &:focus {
      background: ${operationsStatusColors.COMPLETED_faded} !important;
      border-color: ${operationsStatusColors.COMPLETED_faded} !important;;
      color: #ffffff !important;
    }

    &:active {
      background: #09a357;
      border-color: ${operationsStatusColors.COMPLETED};
    }
  }

  button.successBtn,
  .successBtn > button {
    color: ${operationsStatusColors.COMPLETED};
    border-color: ${operationsStatusColors.COMPLETED};

    &:hover, &:focus {
      color: ${operationsStatusColors.COMPLETED_faded} !important;;
      border-color: ${operationsStatusColors.COMPLETED_faded} !important;;
    }
  }

  .full-width {
    width: 100%;
  }

  .warning-text {
    color: var(--ant-warning-color);

    .different-color {
      fill: #d08c05;
    }
  }

  .success-text {
    color: var(--ant-success-color);

    &.has-note:hover {
      color: var(--ant-success-color-hover);
    }
  }

  .danger-text {
    color: var(--ant-error-color);

    .different-color {
      fill: #ce1c1e;
    }
  }

  .primary-text {
    color: var(--ant-primary-color);
  }

  .middle-size-icon {
    font-size: 16px;
  }

  .large-size-icon {
    font-size: 21px;
  }

  .tooltip-icon {
    cursor: help;
  }

  .margin-top-half {
    margin-top: 0.5rem;
  }

  .margin-top-one {
    margin-top: 23px;
  }

  .margin-one {
    margin: 1rem 1rem 0;
  }

  .table-footer .ant-btn-group:first-of-type {
    flex-wrap: wrap;
  }

  button.warningFill,
  .warningFill > button {
    background: ${operationsStatusColors.PLANNED};
    border-color: ${operationsStatusColors.PLANNED};
    color: #ffffff !important;

    &:hover, &:focus {
      background: ${operationsStatusColors.PLANNED_faded} !important;
      border-color: ${operationsStatusColors.PLANNED_faded} !important;;
      color: #ffffff !important;
    }

    &:active {
      background: #09a357;
      border-color: ${operationsStatusColors.PLANNED};
    }
  }

  .warningBtn,
  .warningBtn > button {
    color: var(--ant-warning-color);
    border-color: var(--ant-warning-color);

    &:hover, &:focus {
      color: var(--ant-warning-color-hover) !important;
      border-color: var(--ant-warning-color-hover) !important;
    }
  }

  .dangerBtn {
    color: var(--ant-error-color);
    border-color: var(--ant-error-color);

    &:hover, &:focus {
      color: var(--ant-error-color-hover) !important;
      border-color: var(--ant-error-color-hover) !important;
    }
  }

  button.auto-height {
    height: auto;
  }

  .ant-avatar > img {
    object-fit: contain;
  }

  .invoice-details {
    max-width: 500px;
  }

  td.tablePhoneNumber:not(.ant-descriptions-item) {
    direction: ltr;
  }

  .extra-large.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    height: 50px;
    min-width: 100px;
  }

  .ant-descriptions-rtl .ant-descriptions-item-content.tablePhoneNumber,
  .ant-typography-rtl.tablePhoneNumber,
  .ant-descriptions-rtl .tablePhoneNumber .ant-descriptions-item-content {
    direction: ltr;
    text-align: right;
    justify-content: flex-end;
  }

  .divider-section {
    border-radius: 9px;
    margin: 22px 0 8px;
    background: ${props => (props.medicolize ? 'rgba(231, 220, 245, 0.7)' : 'rgba(220, 244, 245, 0.7)')};
    padding: 4px 35px;
    padding-inline-start: 15px;
    display: block;
    gap: 8px;

    .ant-typography {
      font-size: 14px;
    }

    &.center {
      margin-left: auto;
      margin-right: auto;
    }

    &.block {
      display: flex;
      flex: 1;
      justify-content: center;
      padding-inline-start: 35px;
    }

    &.large .ant-typography {
      font-size: 17px;
    }

    &.no-margin-top {
      margin-top: 0;
    }

    &.small-margin-top {
      margin-top: 8px;
    }

    .ant-form-item {
      margin-bottom: 0;
    }

    &.has-check-box {
      padding-top: 2px;
      padding-bottom: 2px;
    }

    &.has-button {
      padding: 0;

      button {
        padding-top: 6px;
        padding-bottom: 6px;
      }
    }
  }

  .blueTitle {
    color: var(--ant-primary-color) !important;
    margin: 0 !important;
  }

  .ant-form-item-has-error {
    .ant-select-selector {
      border-color: var(--ant-error-color) !important;
    }

    .ant-select-focused .ant-select-selector {
      box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2) !important;
    }
  }

  .ant-select-dropdown.modalDropDown {
    z-index: 1053;
  }

  .active-select {
    box-shadow: ${props => (props.medicolize ? 'rgba(170,133,204,0.8)' : 'rgba(137,180,211,0.8)')} 0 0 1px 1px;
    border-radius: 6px;
  }

  .ant-select .hide-on-select {
    display: none;
  }

  input[type="search"]::-webkit-search-cancel-button {
    display: none;
  }

  .branch-drawer .ant-drawer-content-wrapper {
    max-width: 600px !important;
  }

  .ant-drawer-content-wrapper {
    width: 70% !important;
    @media screen and (max-width: 992px) {
      width: 95vw !important;
    }
  }

  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: var(--ant-primary-color) !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  .ant-btn.focused:not(:focus):not(:hover) {
    color: var(--ant-primary-color);
    border-color: var(--ant-primary-color);
  }

  //Make event tooltip full height
  .rbc-overlay {
    padding: 0 !important;
    max-height: 200px;
    overflow: scroll;

    .rbc-overlay-header {
      margin: 0 10px;
      padding: 3px 0;
    }

    .ant-tag {
      max-height: 25px !important;
    }
  }

  .child-teeth-icon {
    position: absolute;
    left: 0;
    top: 0;

    &.ant-btn-sm .anticon {
      font-size: 23px;
    }

    .anticon {
      font-size: 33px;
    }

    .ant-badge {
      .ant-badge-count-sm {
        min-width: 14px;
        height: 14px;
        font-size: 10px;
        line-height: 14px;
        border-radius: 14px;
        top: 7px;
        right: 3px;
        z-index: 10;
      }

      &.ant-badge-rtl .ant-badge-count-sm {
        left: 3px;
        right: auto;
      }
    }

    svg {
      width: 1.6em;
      height: 1.6em;
    }

    @media screen and (max-width: 1500px) {
      max-width: 45px;
      padding: 0 2px;
      row-gap: 1px;
      flex-wrap: wrap;
      .ant-btn-group {
        justify-content: center;
        flex-direction: column;
        align-items: center;

        button {
          border-start-end-radius: 8px !important;
          border-end-end-radius: 8px !important;
          border-start-start-radius: 8px !important;
          border-end-start-radius: 8px !important;
          margin-bottom: 1px;
        }
      }
    }
  }

  .ant-badge-rtl .ant-badge-count {
    direction: ltr;
  }

  .ant-tag.type-tag {
    margin-top: 2px;
    font-size: 12px;
    padding: 1px 4px;
    line-height: 14px;
  }

  .ant-table-cell div.ant-tag {
    display: inline-block;
    border-radius: 4px;
    line-height: 20px;
    padding: 4px 5px;
  }

  .dark-calendar {
    color: #ffffff;

    .eventTitle .ant-tag:not(.reference-id), .ant-typography, .ant-descriptions-item-label, .anticon-form {
      color: #ffffff;
    }

    .ant-descriptions-item-content {
      .ant-typography {
        color: #1a1a1a;
      }

      a {
        color: var(--ant-primary-color);

        &:hover {
          color: var(--ant-primary-color-active);
        }
      }
    }

    .ant-btn-primary a {
      color: #ffffff !important;
    }

    a {
      color: #ffffff;

      &:hover {
        color: black;
      }
    }

    .ant-tag {
      border: 0.1px solid #2a2a2a;
    }
  }

  .printed-page {
    display: none !important;
    @media print {
      display: flex !important;
    }
  }

  .ant-input-number-group-rtl {
    .ant-input-number-rtl:first-child {
      border-radius: 0 2px 2px 0;
    }

    .ant-input-number-group-addon {
      border-radius: 2px 0 0 2px;
      border-right: 0;
      border-left: 1px solid #d9d9d9;
    }
  }

  .ant-tag.ant-tag-has-color .ant-typography {
    color: #ffffff !important;
  }

  .ant-tooltip-inner .ant-tag {
    &.upper, &.lower {
      background: #ffffff;
    }
  }

  .ant-table-row-selected .ant-table-cell-row-hover {
    background-color: ${props => (props.medicolize ? '#f1d7fc' : '#b4ebfa')} !important;
  }

  .chart-header-button svg {
    margin-top: 1px;
    width: 19px;
    height: 19px;
  }

  .chart-content-scroll {
    overflow-x: scroll;
    max-width: 90vw;
    margin: 0;

    .chart-teeth {
      min-width: 300px;
      padding: 0 !important;
      margin: 0 auto;

      .single-tooth {
        height: auto !important;
        max-height: 240px !important;
        min-height: 50px !important;
        > span svg {
          min-width: 20px !important;
          max-width: 50px !important;
          width: 5vw !important;
          height: auto !important;
        }

        .number {
          font-size: 9px !important;
        }

        .ant-space {
          display: none;
        }
      }
    }
  }

  .empty-table-row {
    background: #ffffff;
  }

  .ant-tabs-dropdown-menu-item {
    text-align: center;

    .hiddenIcon.anticon-drag {
      display: none;
    }
  }

  .calendarPopover {
    max-width: 95vw !important;

    .ant-popover-inner {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

      .ant-descriptions-item-content, .ant-descriptions-item-label {
        padding: 4px 8px !important;
      }

      .ant-btn-link {
        height: auto;
      }
    }

    .phone-number-text {
      margin: 0;
    }

    .ant-popover-inner {
      display: flex;
      padding: 0;
      border-radius: 10px;
    }

    tbody .ant-descriptions-row:first-of-type .ant-descriptions-item-content {
      border-radius: 10px 10px 0 0;
    }

    tbody .ant-descriptions-row:last-of-type .ant-descriptions-item-content {
      border-radius: 0 0 10px 10px;
    }
  }

  .ant-cascader-menus {
    > .ant-cascader-menu:first-child {
      min-width: 200px !important;

      .ant-cascader-menu-item {
        width: 200px !important;
      }
    }

    > .ant-cascader-menu:last-child {
      .ant-cascader-menu-item {
        max-width: 500px !important;
      }
    }

    .ant-cascader-menu-item {
      white-space: break-spaces;
    }
  }

  .break-spaces, .ant-space-item > .ant-tag {
    white-space: break-spaces;
  }

  .min-width-status {
    min-width: 30px;
    text-align: center;
  }

  .ant-table-summary {
    background: #fafafa;
  }

  .generate-expenses-table {
    background: var(--main-background);
    padding: 10px 5px;
    border-radius: 5px;
  }

  .ant-input-number-group-wrapper {
    .ant-input-number {
      input {
        border-radius: 2px 0 0 2px;
      }

      &.ant-input-number-rtl input {
        border-radius: 0 2px 2px 0;
      }
    }
  }

  .input-no-border {
    border: 0;
    width: 150px;
    max-width: 100%;

    input {
      background-color: rgba(0, 0, 0, 0.02) !important;
    }

    &.insurance-field {
      background: #fdfdfd;
    }
  }

  //Fix datepicker text not in center
  .ant-picker-cell-inner {
    text-align: center;
  }

  .ant-dropdown-menu {
    max-width: 100vw;
    max-height: 50vh;
    overflow: scroll;

    .ant-dropdown-menu-item {
      white-space: break-spaces;
    }
  }

  .ant-select-dropdown {
    max-width: 85vw;

    .ant-space-item .ant-typography {
      white-space: break-spaces;
    }
  }

  .ant-tag {
    font-weight: 700;
    font-size: 13px;

    span {
      font-weight: inherit;
    }

    .tag-button {
      color: inherit;
    }
  }

  .ant-picker-preset .ant-tag, .ant-tag.link-item, .pointer-el {
    cursor: pointer;
  }

  .ant-picker {
    width: 100%;
  }

  .rotateIfRTL {
    transform: ${props => props.rtl && 'rotate(180deg)'};

    &.anticon {
      transform: ${props => props.rtl && 'rotate(180deg)'} !important;
    }
  }

  .scaleIfRTL {
    transform: ${props => props.rtl && 'scaleX(-1)'};
  }

  .modal-select-multiple .ant-select-selector {
    min-width: 150px;
    text-align: ${props => (props.rtl ? 'right' : 'left')};
  }

  .duplicate-patients-overlay .ant-popover-inner {
    max-height: 50vh;
    overflow-y: scroll;

    .ant-divider-horizontal {
      margin: 12px 0;
    }

    .patient-container {
      background-color: rgba(0, 0, 0, 0.04);
      margin-bottom: 5px;
      border-radius: 8px;
      padding: 12px 10px;
    }
  }

  .tag-icon {
    width: 27px;
    height: 27px;
    border-radius: 27px;
    background-color: #f0f2f5;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    img {
      width: 19px;
      height: 19px
    }
  }

  .image-icon {
    width: 37px;
    height: 37px;
    border-radius: 37px;
  }

  .ant-notification .ant-notification-notice-description div {
    white-space: pre-line;
    overflow-wrap: anywhere;
  }

  .hide-clear .ant-picker-clear {
    display: none !important;
  }

  .hide-except-on-print {
    display: none;
  }

  .ant-descriptions-item-label {
    min-width: 90px;
  }

  @media print {
    audio {
      display: none;
    }

    .hide-except-on-print {
      display: block !important;
    }
  }

  @media screen and (max-width: 1300px) {
    .ant-row {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  @media screen and (max-width: 992px) {
    html {
      font-size: 13px !important;
    }

    .ant-table-cell,
    .ant-table-cell .ant-typography,
    .ant-descriptions-item-label .ant-typography,
    .ant-descriptions-item-label span,
    .ant-descriptions-item-content,
    .ant-descriptions-item-content .ant-typography {
      font-size: 13px !important;
    }

    .ant-descriptions-item-label {
      min-width: 70px;
    }

    .chart-header-button svg {
      width: 17px;
      height: 17px;
    }
  }

  @media screen and (max-width: 576px) {
    html {
      font-size: 12px !important;
    }

    .ant-picker-panels {
      flex-direction: column;
    }

    .hideOnXSmall > span:not(.ant-btn-icon) {
      display: none !important;
    }

    .ant-table-cell,
    .ant-table-cell .ant-typography,
    .ant-descriptions-item-label .ant-typography,
    .ant-descriptions-item-label span,
    .ant-descriptions-item-content,
    .ant-descriptions-item-content .ant-typography {
      font-size: 11px !important;
    }

    .chart-header-button svg {
      width: 15px;
      height: 15px;
    }
  }
`
